import {ApiResponse, ListQueryParams} from '../ApiClient'
import {GetAPIDomain, GetAPIHeaders, GetAPIHeadersPatch} from '../Helper'

export class CafeOrdersQueryParams extends ListQueryParams {
  WithStatus(value: any) {
    this.WithParam('status', value)
    return this
  }

  WithUserId(value: string) {
    this.WithParam('userId', value)
    return this
  }

  WithProductId(value: string) {
    this.WithParam('productId', value)
    return this
  }

  WithDateRange(startDate: string, endDate: string) {
    this.WithParam('startDate', startDate)
    this.WithParam('endDate', endDate)
    return this
  }

  WithSiteId(value: string) {
    this.WithParam('siteId', value)
    return this
  }

  WithDate(date: string) {
    this.WithParam('date', date)
    return this
  }

  WithOpenOrders(value: boolean) {
    this.WithParam('openOrders', value)
    return this
  }
}

export class CafeOrdersClient {
  static async List(params: CafeOrdersQueryParams) {
    var query = (await GetAPIDomain()) + '/cafe/orders' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async ListBumpScreen(params: CafeOrdersQueryParams) {
    var query = (await GetAPIDomain()) + '/cafe/orders/bump-screen' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async Get(id: string) {
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/cafe/orders/' + id, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async Delete(id: string) {
    var query = (await GetAPIDomain()) + '/cafe/orders/' + id

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
        method: 'DELETE',
      })
    )
  }

  static async UpdateOrderStatus(id: string, status: string) {
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/cafe/orders/' + id, {
        method: 'PATCH',
        headers: GetAPIHeadersPatch(),
        credentials: 'include',
        body: JSON.stringify([{op: 'replace', path: 'status', value: status}]),
      })
    )
  }

  static async ExportToCsv(params: CafeOrdersQueryParams) {
    var apiDomain = await GetAPIDomain()
    let response = await fetch(apiDomain + '/cafe/orders/csv' + params.GenerateQueryString(), {
      headers: GetAPIHeaders(),
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({}),
    })

    return await response.blob()
  }
}
